export const detectLocalIpAddress = stream => {
  const promise = new Promise((resolve, reject) => {
    const configuration = {
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
    };
    const pc = new RTCPeerConnection(configuration);
    pc.onicecandidate = event => {
      const candidate = event.candidate;
      if (candidate) {
        if (candidate.type === "srflx") {
          resolve(candidate.ip);
        }
      } else {
        pc.close();
      }
    };
    pc.addStream(stream);
    pc.createOffer().then(offer => {
      pc.setLocalDescription(offer);
    });
  });
  return promise;
};

export const detectLocalIpAddress2 = () => {
  const promise = new Promise((resolve, reject) => {
    const configuration = {
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
    };
    const pc = new RTCPeerConnection(configuration);
    pc.onicecandidate = event => {
      const candidate = event.candidate;
      if (candidate) {
        if (candidate.type === "srflx") {
          resolve(candidate.ip);
        }
      } else {
        pc.close();
      }
    };
  });
  return promise;
};






// WEBPACK FOOTER //
// ./src/misc/localIpAddress.js